ACC.langcurrency = {

	_autoload: [
		"sortCountryLanguageSelector",
		"bindLangCurrencySelector",
		"countryLanguageSelector",
		"selectSEO",
		"selectSEOButton"

		
	],

	bindLangCurrencySelector: function (){

		$('#lang-selector').change(function(){
			$('#lang-form').submit();
		});

		$('#currency-selector').change(function(){
			$('#currency-form').submit();
		});
	},
	countryLanguageSelector : function (){
		$('li .country-language-item').on('click', function(e){
			
			var compnent = $(this).parent().html()
			var code = $(this).data('code') , codeCountry= $(this).data('codecountry');
			$(this).closest(".amds-select-option").find("#code").attr('value',code);
			$(this).closest(".amds-select-option").find("#codeCountry").attr('value',codeCountry);
			$(this).closest(".amds-select-option").find("#langCountryMenu").html(compnent)
		})
		$('li .country-item').on('click', function(e){
			var compnent = $(this).parent().html()
			var codeCountry= $(this).data('codecountry');
			$(this).closest(".amds-select-option").find("#codeCountry").attr('value',codeCountry);
			$(this).closest(".amds-select-option").find("#countryMenu").html(compnent)
		})
	},
	sortCountryLanguageSelector: function (){

		$(".dropdown-menu").each(function(){
			  $(this).html($(this).children('li').sort(function(a, b){
			  	return ($(".country-item,.country-language-item",a).data('codecountry')) < ($(".country-item,.country-language-item",b).data('codecountry')) ? 1 : -1;
			  }));
			});
		$(".dropdown-menu").each(function(){
			  $(this).html($(this).children('li').sort(function(a, b){
			  	return ($(".country-item,.country-language-item",a).data('codecountry')) == ($(".country-item,.country-language-item",b).data('codecountry')) && ($(a).data('defaultlang')) == ($(".country-item,.country-language-item",b).data('code')) ? 1 : -1;
			  }));
			});
	},
	

	selectSEO : function()
	{
		$('.selectPopin').on('click', function(e){


			var country_seo = $(this).data('country-seo') ;
			
			
			var lang_seo = $(this).data('lang-seo') ;
			var code = $(this).data('code') , codeCountry= $(this).data('codecountry');
			var item="";
			item+='<div class="country-language-item clearfix" data-code="'+code+'" data-codecountry ="'+codeCountry+'" >';
			item+='<div class="img-country bg-'+codeCountry+'"></div>'
			item+='<span class="contry-language-txt">'+country_seo+' ('+lang_seo+')</span>' 
			item+='</div>'
			$(this).closest(".amds-select-option").find("#code").attr('value',code);
			$(this).closest(".amds-select-option").find("#countryCode").attr('value',codeCountry);

			$(this).closest(".amds-select-option").find("#langCountryMenu").html(item)
			
		})
	},
	
	selectSEOButton : function()
	{
		$('#btn_seo_popin').on('click', function(e){

		
			var code =	document.getElementById("code").value;
			var codeCountry =	document.getElementById("countryCode").value;
		
			var urlRedirect =  "/"+codeCountry+"/"+code;
			var currentLocation = window.location.pathname; ///FR/fr/login
			
			
				var chars = currentLocation.split('/');
			
				if(chars.length > 2 && chars[2] !== null)
				{
				window.location.href = urlRedirect+ currentLocation.substring(currentLocation.indexOf(chars[2])+ chars[2].length);
				
				}else 
				{
					
					window.location.href = urlRedirect;
					
				}
			
			
		})
	}
	
	

	
};